import { render, staticRenderFns } from "./EditCompression.vue?vue&type=template&id=97b2d72e&scoped=true"
import script from "./EditCompression.vue?vue&type=script&lang=js"
export * from "./EditCompression.vue?vue&type=script&lang=js"
import style0 from "./EditCompression.vue?vue&type=style&index=0&id=97b2d72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b2d72e",
  null
  
)

export default component.exports